import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const helpCenterSettingsSupportWebsiteEditRoute: InvariantJiraRoute = {
	name: 'helpcenter-settings-support-website-details-edit',
	path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/support-website/edit/:pageId?',
	exact: true,
};
